import React from 'react';
import { Mail, Phone, Globe, Instagram, Facebook, MapPin } from 'lucide-react';
export function Contact() {
  return <section id="contacto" className="py-20 md:py-32 bg-brand-primary" data-id="element-64">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-65">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-66">
          {/* Left Column - Info */}
          <div data-id="element-67">
            <h2 className="text-3xl md:text-5xl font-serif text-brand-cream mb-8" data-id="element-68">
              Contáctanos
            </h2>

            <div className="space-y-6 mb-12" data-id="element-69">
              <div className="flex items-center" data-id="element-70">
                <Mail className="text-brand-gold mr-4" size={24} data-id="element-71" />
                <a href="mailto:directorcabrera@gmail.com" className="text-brand-cream/80 hover:text-brand-gold transition-colors text-lg" data-id="element-72">
                  directorcabrera@gmail.com
                </a>
              </div>
              <div className="flex items-center" data-id="element-73">
                <Phone className="text-brand-gold mr-4" size={24} data-id="element-74" />
                <a href="tel:+573002889249" className="text-brand-cream/80 hover:text-brand-gold transition-colors text-lg" data-id="element-75">
                  +57 300 2889249
                </a>
              </div>
              <div className="flex items-center" data-id="element-76">
                <Globe className="text-brand-gold mr-4" size={24} data-id="element-77" />
                <a href="https://cabrerarestobar.com" className="text-brand-cream/80 hover:text-brand-gold transition-colors text-lg" data-id="element-78">
                  cabrerarestobar.com
                </a>
              </div>
            </div>

            <div className="space-y-4" data-id="element-79">
              <h4 className="text-brand-gold font-serif text-xl mb-4" data-id="element-80">
                Síguenos en redes
              </h4>
              <div className="flex space-x-6" data-id="element-81">
                <a href="https://instagram.com/cabrera.restobar" target="_blank" rel="noreferrer" className="flex items-center text-brand-cream/80 hover:text-brand-gold transition-colors" data-id="element-82">
                  <Instagram className="mr-2" size={20} data-id="element-83" />
                  <span data-id="element-84">@cabrera.restobar</span>
                </a>
                <a href="https://www.facebook.com/cabrera.restobar" target="_blank" rel="noreferrer" className="flex items-center text-brand-cream/80 hover:text-brand-gold transition-colors" data-id="element-85">
                  <Facebook className="mr-2" size={20} data-id="element-86" />
                  <span data-id="element-87">Facebook</span>
                </a>
              </div>
            </div>
          </div>

          {/* Right Column - Map Placeholder */}
          <div className="bg-brand-secondary p-8 rounded-3xl border border-brand-gold/20 h-full min-h-[400px] flex flex-col items-center justify-center text-center relative overflow-hidden group" data-id="element-88">
            <div className="absolute inset-0 bg-[url('https://images.unsplash.com/photo-1524661135-423995f22d0b?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=80')] opacity-20 bg-cover bg-center group-hover:scale-105 transition-transform duration-700" data-id="element-89"></div>
            <div className="absolute inset-0 bg-brand-primary/60" data-id="element-90"></div>

            <div className="relative z-10 flex flex-col items-center" data-id="element-91">
              <div className="w-16 h-16 bg-brand-gold/20 rounded-full flex items-center justify-center mb-6 border border-brand-gold/50" data-id="element-92">
                <MapPin className="text-brand-gold" size={32} data-id="element-93" />
              </div>
              <h3 className="text-2xl font-serif text-brand-cream mb-2" data-id="element-94">
                Sede Principal: Zona T
              </h3>
              <p className="text-brand-cream/70 text-lg" data-id="element-95">
                Cra. 12a #83-23, Bogotá
              </p>

              <a href="https://maps.google.com" target="_blank" rel="noreferrer" className="mt-8 px-6 py-2 rounded-full border border-brand-gold text-brand-gold hover:bg-brand-gold hover:text-brand-primary transition-colors text-sm font-semibold" data-id="element-96">
                ABRIR EN MAPS
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>;
}